import React, { useState } from 'react';

import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';

import axios from 'axios';

import { LinkContainer } from 'react-router-bootstrap';
import { Field, reduxForm } from 'redux-form';

import FormField from '../field/FormField';
import Captcha from '../captcha/Captcha';

const validate = (values) => {
  const errors = {}

  if (!values.username) {
    errors.username = 'Required';
  } else if (values.username.length > 50) {
    errors.username = 'Max 50 characters';
  } else if (values.username.length < 3 || !values.username.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)) {
    errors.username = 'Invalid email';
  } else if (values.username.includes(" ")) {
    errors.username = 'Email cannot contain spaces';
  }

  if (!values.password) {
    errors.password = 'Required';
  } else if (values.password.length > 50) {
    errors.password = 'Max 50 characters';
  } else if (values.password.length < 8) {
    errors.password = 'Min 8 characters';
  } else if (!values.password.match(/^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^+=*]).*$/)) {
    errors.password = 'At least one upper and lower case letter, digit and special character (!@#$%^+=*) required';
  }

  if (values.confirm !== values.password) {
    errors.confirm = 'Does not match';
  }

  if (!values.reCaptcha) {
    errors.reCaptcha = 'Invalid captcha response';
  }
  return errors;
}

const Register = (props) => {
  const [error, setError] = useState(null);

  const onSubmit = (values) => {
    return axios.post(`${props.SERVER_URLS.api}/register`, {
      username: values.username,
      password: values.password,
      reCaptcha: values.reCaptcha,
    }).then(() => {
      localStorage.setItem('user_id', values.username);
      setError(null);
    }).catch((error) => {
      setError((error && error.response && error.response.data) || 'Failed to register with unknown error')
      return Promise.reject(error);
    });
  };

  const { handleSubmit, submitting } = props;

  return (
    <>
      {error &&
        <Alert variant="error" onClose={() => setError(null)} dismissible>
          {error}
        </Alert>
      }
      <Row className="justify-content-md-center">
        <Col className="jumbotron col-sm-8">
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Field name="username" type="text" component={FormField} label="Email" />
            <Field name="password" type="password" component={FormField} label="Password" />
            <Field name="confirm" type="password" component={FormField} label="Confirm Password" />
            <Field name="reCaptcha" component={Captcha} />
            <div className="button-row">
              <LinkContainer to="/">
                <button type="button" className="btn btn-light">
                  Cancel
                </button>
              </LinkContainer>
              <Button type="submit" variant="primary" disabled={submitting}>
                Register
              </Button>
            </div>
          </Form>
        </Col>
      </Row>
    </>
  );
};

export default reduxForm({
  form: 'register',
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: true,
  validate,
})(Register);
